"use client";

import { createContext, useContext, useEffect, useMemo, useState } from 'react'

type Segment = 'new'|'first_time'|'regular'|'loyal'|'at_risk'|'dormant'|'vip'

type IdentifyResponse =
  | { recognized:false }
  | { recognized:true; segment:Segment; hasActiveSub:boolean; lastOrderDays:number|null; pendingDiscountCode:string|null }

interface OfferState {
  recognized: boolean
  segment: Segment | null
  pendingDiscountCode: string | null
}

const OfferContext = createContext<OfferState>({ recognized: false, segment: null, pendingDiscountCode: null })

export function OfferProvider({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<OfferState>({ recognized: false, segment: null, pendingDiscountCode: null })

  useEffect(() => {
    const abort = new AbortController()
    ;(async () => {
      try {
        const res = await fetch('/api/identify', { credentials: 'include', signal: abort.signal })
        if (!res.ok) return
        const data: IdentifyResponse = await res.json()
        if (data.recognized) {
          setState({ recognized: true, segment: data.segment, pendingDiscountCode: data.pendingDiscountCode })
        } else {
          setState({ recognized: false, segment: null, pendingDiscountCode: null })
        }
      } catch {}
    })()
    return () => abort.abort()
  }, [])

  const value = useMemo(() => state, [state])
  return <OfferContext.Provider value={value}>{children}</OfferContext.Provider>
}

export function useOffer() {
  return useContext(OfferContext)
}

